<template>
  <div class="series-page white-container full-page-container common-table">
    <el-table ref="multipleTable" size="small" :data="list" style="width: 100%">
      <el-table-column prop="tagName" label="运动系列" width="120" />
      <el-table-column prop="equipmentSeriesOfCourseList" label="当前商品" width="700">
        <template v-slot="{row}">
          <div class="flex">
            <div v-for="(item) in row.equipmentCommodityList" :key="item.id" style="margin-right: 50px;">
              <div class="img-box" style="width:90px; height: 90px">
                <img v-if="item.isDelete === 1" class="invalid-flag" src="@/assets/images/product-invalid.svg">
                <img class="product-img" :src="item.mediaLink" alt="">
              </div>
              <div :title="item.productNo" class="sku">{{ item.productNo }}</div>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template v-slot="{row}">
          <el-button size="small" type="text" class="link-color" @click="handleEdit(row)">管理关联商品</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>

</template>
<script>

export default {
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$Api.equipment.quipmentManagementList().then(res => {
        if (res && res.length) {
          // res.forEach(item => {
          //   item.equipmentSeriesOfCourseList = [
          //     {
          //       url: 'https://uadev-1257321318.file.myqcloud.com/static/image/dev/equipment_centera632b6643483c353b944f9705a65c81a.png?imageMogr2/format/webp',
          //       sku: '3025-052-001',
          //     },
          //     {
          //       url: 'https://uadev-1257321318.file.myqcloud.com/static/image/dev/equipment_centera632b6643483c353b944f9705a65c81a.png?imageMogr2/format/webp',
          //       sku: '3025-052-002',
          //     },
          //     {
          //       url: 'https://uadev-1257321318.file.myqcloud.com/static/image/dev/equipment_centera632b6643483c353b944f9705a65c81a.png?imageMogr2/format/webp',
          //       sku: '3025-052-003',
          //     },
          //     {
          //       url: 'https://uadev-1257321318.file.myqcloud.com/static/image/dev/equipment_centera632b6643483c353b944f9705a65c81a.png?imageMogr2/format/webp',
          //       sku: '3025-052-004',
          //     },
          //     {
          //       url: 'https://uadev-1257321318.file.myqcloud.com/static/image/dev/equipment_centera632b6643483c353b944f9705a65c81a.png?imageMogr2/format/webp',
          //       sku: '3025-052-005',
          //     },
          //     {
          //       url: 'https://uadev-1257321318.file.myqcloud.com/static/image/dev/equipment_centera632b6643483c353b944f9705a65c81a.png?imageMogr2/format/webp',
          //       sku: '3025-052-006',
          //     },
          //   ];
          // });
          this.list = res;
        }
      });
    },
    handleEdit(row) {
      this.$router.push({ path: '/equipment/seriesOfClass/edit', query: { tagId: row.tagId } });
    },
  },
};
</script>

<style lang="less" scoped>

.img-box {
  position: relative;
  .invalid-flag {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%) rotateZ(20deg);
    z-index: 2;
    width: 92px;
    height: 36px;
  }
  .product-img {
    width: 100%;
    height: 100%;
  }
}
.series-page.full-page-container {
  min-height: calc(100vh - 180px) !important;
  padding-bottom: 0 !important;
}
.series-page {
  .equiment {
    width: 90px;
    height: 90px;
    border: 1px solid #e3e3e5;
    vertical-align: top;
    &.equiment {
      margin-right: 50px;
    }
  }
  .sku {
    width: 90px;
    overflow: hidden;
    text-overflow: ellipsis;
    background: #e3e3e5;
    font-size: 14px;
    line-height: 20px;
    color: #494949;
    text-indent: 2px;
  }
}
</style>
